import { Base } from '../../components/base-component';
import { AnalyticsService } from '../../services/analytics.service';

import './form-item-life-cover-insurance.component.scss';

export class FormItemLifeCoverInsurance extends Base {

	form: HTMLFormElement;
	submitBtn: Element;

	constructor(element: Element) {
		super(element);
	}

	init() {
		this.form = this.element.querySelector('form') as HTMLFormElement;
		this.submitBtn = this.element.querySelector('.js-life-cover-insurance__button');
	}

	bindEvents() {

		this.submitBtn.addEventListener('click', (event) => {
			const _button = event.target as HTMLFormElement;
			const _form = _button.closest('form') as HTMLFormElement;
			const formFields: any = _form.querySelectorAll('input, select');
			this.validationService.validate(formFields);
			const valid = Array.from(_form.querySelectorAll(".form__group--error"));
			if (valid.length == 0) {
				this.submitForm(_form);
			}
		});
	}

	submitForm(form: HTMLFormElement) {
		// success screens
		const loader = form.querySelector('.form__loader--container');
		const thankYou = form.querySelector('.form__thankyou--container');
		const fieldsContainer: any = form.querySelector('.form__fields--container');

		// additional containers
		let success = form.querySelector('.form__success--container');
		let error = form.querySelector('.form__error--container');

		let postData = '';

		let serviceType: any = form.querySelector("input[name=serviceType]");
		if (serviceType) {
			postData += 'service-type=' + serviceType.value;
		}
		let product: any = form.querySelector("input[name=product]");
		if (product) {
			postData += '&product=' + product.value;
		}
		let description: any = form.querySelector("input[name=description]");
		if (description) {
			postData += '&description=' + description.value;
		}
		let email: any = form.querySelector("input[name=email]");
		if (email) {
			postData += '&email=' + email.value;
		}
		let recipient: any = form.querySelector("input[name=recipient]");
		if (recipient) {
			postData += '&recipient=' + recipient.value;
		}
		let subject: any = form.querySelector("input[name=subject]");
		if (subject) {
			postData += '&subject=' + subject.value;
		}
		let redirect: any = form.querySelector("input[name=redirect]");
		if (redirect) {
			postData += '&redirect=' + redirect.value;
		}
		let _firstName: any = this.form.querySelector('input[name=first-name]');
		if (_firstName) {
			postData += '&firstname=' + _firstName.value;
		}
		let _surname: any = this.form.querySelector('input[name=last-name]');
		if (_surname) {
			postData += '&surname=' + _surname.value;
		}
		let _contact: any = this.form.querySelector('input[name=contact-number]');
		if (_contact) {
			postData += '&contact=' + _contact.value;
		}

		// loader + hide form
		loader.classList.add('active');
		fieldsContainer.classList.add('hidden');

		// variables
		let analyticsService = new AnalyticsService();
		let url = "/services/lifecoverservice.jsp";
		const config = {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				"Access-Control-Allow-Origin": "*",
				'X-Requested-With': 'XMLHttpRequest'
			}
		}

		// service
		this.formsService.postForm(url, postData, config).then(response => {
			loader.classList.remove('active');
			if (!response.data || (response.data.match(/(invalid)/gi))) {
				analyticsService.dtmRecordSiteError('noerrorcode|invalid response');
				thankYou.classList.add('active');
				success.classList.remove('active');
				success.classList.add('hidden');
				error.classList.remove('hidden');
				error.classList.add('active');
				
			} else {
				analyticsService.dtmFormComplete('complete', response.code);
				thankYou.classList.add('active');
				error.classList.remove('active');
				error.classList.add('hidden');
				success.classList.remove('hidden');
				success.classList.add('active');
				
			}
		}).catch(response => {
			// service failed
			analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
			loader.classList.remove('active');
			fieldsContainer.classList.remove('hidden');
		});
	}
}



// WEBPACK FOOTER //
// ./components-wpbbsa/form-item-life-cover-insurance/form-item-life-cover-insurance.component.ts